
import { ArrayMinSize, IsDefined, IsIn, IsNotEmpty, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { RoleEnum } from '../../enum/forecaster';

export class OrderFromTextRequestDto {
  @IsDefined()
  @ArrayMinSize(1)
  @ValidateNested({each: true})
  @Type(() => ChatMessageDto)
  history: ChatMessageDto[];
}

export class ChatMessageDto {
  @IsNotEmpty()
  @IsString()
  @IsIn(Object.values(RoleEnum))
  role: RoleEnum;

  @IsNotEmpty()
  @IsString()
  content: string;
}